import {UndoableAction} from "../common/UndoableAction";
import {ItemModelType, WorkspaceModelType} from "@stores/WorkspaceStore";
import {
    updateWorkspaceArchivedIdsSet, updateWorkspaceChildIdsAdd, updateWorkspaceChildIdsRemove,
    updateWorkspaceChildIdsSet,
    updateWorkspaceTrashedIdsSet,
    UpdateWorkspaceServices
} from "./updateWorkspace";
import {updateItemChildIdsAdd, updateItemChildIdsRemove} from "../item/updateItem";
import {DataSourceManager} from "@stores/dataSources/DataSourceManager";
import {CrudServices} from "../../platform/services/types/ServiceDependencies";


export class UndoableUpdateWorkspaceChildIdsSet implements UndoableAction {
    private services: UpdateWorkspaceServices;
    workspaceMST: WorkspaceModelType;
    childIds: string[];
    oldChildIds: string[];
    dbQueue?: Promise<any>;

    constructor(services: UpdateWorkspaceServices, workspaceMST: WorkspaceModelType, childIds: string[], dbChangeQueue?: Promise<any>) {
        this.services = services;
        this.workspaceMST = workspaceMST;
        this.childIds = childIds;
        this.oldChildIds = workspaceMST.childIds.toJSON();
        this.dbQueue = dbChangeQueue;
    }

    execute(): Promise<any> {
        return updateWorkspaceChildIdsSet(this.services, this.workspaceMST, this.childIds, this.dbQueue);
    }

    undo(): Promise<any> {
        return updateWorkspaceChildIdsSet(this.services, this.workspaceMST, this.oldChildIds, this.dbQueue);
    }
}

export class UndoableUpdateWorkspaceArchivedSet implements UndoableAction {
    private services: UpdateWorkspaceServices;
    workspaceMST: WorkspaceModelType;
    childIds: string[];
    oldChildIds: string[];
    dbQueue?: Promise<any>;

    constructor(services: UpdateWorkspaceServices, workspaceMST: WorkspaceModelType, childIds: string[], dbChangeQueue?: Promise<any>) {
        this.services = services;
        this.workspaceMST = workspaceMST;
        this.childIds = childIds;
        this.oldChildIds = workspaceMST.childIds.toJSON();
        this.dbQueue = dbChangeQueue;
    }

    execute(): Promise<any> {
        return updateWorkspaceArchivedIdsSet(this.services, this.workspaceMST, this.childIds, this.dbQueue);
    }

    undo(): Promise<any> {
        return updateWorkspaceArchivedIdsSet(this.services, this.workspaceMST, this.oldChildIds, this.dbQueue);
    }
}


export class UndoableUpdateWorkspaceTrashedSet implements UndoableAction {
    private services: UpdateWorkspaceServices;
    workspaceMST: WorkspaceModelType;
    childIds: string[];
    oldChildIds: string[];
    dbQueue?: Promise<any>;

    constructor(services: UpdateWorkspaceServices, workspaceMST: WorkspaceModelType, childIds: string[], dbChangeQueue?: Promise<any>) {
        this.services = services;
        this.workspaceMST = workspaceMST;
        this.childIds = childIds;
        this.oldChildIds = workspaceMST.childIds.toJSON();
        this.dbQueue = dbChangeQueue;
    }

    execute(): Promise<any> {
        return updateWorkspaceTrashedIdsSet(this.services, this.workspaceMST, this.childIds, this.dbQueue);
    }

    undo(): Promise<any> {
        return updateWorkspaceTrashedIdsSet(this.services, this.workspaceMST, this.oldChildIds, this.dbQueue);
    }
}

export class UndoableUpdateWorkspaceChildIdsRemove implements UndoableAction {
    private services: UpdateWorkspaceServices;
    workspaceMST: WorkspaceModelType;
    childId: string;
    positionInWorkspace?: number;

    constructor(services: UpdateWorkspaceServices, workspaceMST: WorkspaceModelType, childId: string) {
        this.services = services;
        this.workspaceMST = workspaceMST;
        this.childId = childId;
    }

    execute(): Promise<any> {
        this.positionInWorkspace = this.workspaceMST.childIds.indexOf(this.childId);
        return updateWorkspaceChildIdsRemove(this.services, this.workspaceMST, this.childId);
    }

    undo(): Promise<any> {
        return updateWorkspaceChildIdsAdd(this.services, this.workspaceMST, this.childId, this.positionInWorkspace);
    }
}

export class UndoableUpdateItemChildIdsAdd implements UndoableAction {
    private services: CrudServices;
    private dsManager: DataSourceManager;
    workspaceMST: WorkspaceModelType;
    mstItem: ItemModelType;
    childId: string;
    index?: number;
    positionInWorkspace?: number;

    constructor(
        services: CrudServices,
        dsManager: DataSourceManager,
        mstItem: ItemModelType,
        childId: string,
        workspaceMST: WorkspaceModelType,
        index?: number
    ) {
        this.services = services;
        this.dsManager = dsManager;
        this.mstItem = mstItem;
        this.workspaceMST = workspaceMST;
        this.childId = childId;
        this.index = index;
    }

    execute(): Promise<any> {
        this.positionInWorkspace = this.workspaceMST.childIds.indexOf(this.childId);
        return updateItemChildIdsAdd(this.services, this.dsManager, this.mstItem, this.childId, this.workspaceMST, this.index);
    }

    undo(): Promise<any> {
        return updateItemChildIdsRemove(this.services, this.dsManager, this.mstItem.id, this.childId, this.workspaceMST);
    }
}
